import { settingsAboutRoute } from '#shared/lib/routes';
import { getMenuSections } from './getMenuSections';

export const getDefaultRootRoute = (): string => {
    const menuItems = getMenuSections().flat();

    return menuItems[0]?.href ?? settingsAboutRoute.getUrl();
};
